import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from './firebase';

// Firestore supports max 10 values in an 'in' clause; chunk helper
const chunk = <T,>(arr: T[], size: number): T[][] => {
  const out: T[][] = [];
  for (let i = 0; i < arr.length; i += size) out.push(arr.slice(i, i + size));
  return out;
};

/**
 * Count active outlets assigned to a route using locality -> route mapping.
 * - Fetches localities with routeId
 * - Queries outlets by localityId in chunks of 10, filtering status == 'active'
 */
export async function countActiveOutletsForRoute(routeId: string): Promise<number> {
  if (!routeId) return 0;

  // Step 1: Get localities mapped to this route
  const locSnap = await getDocs(
    query(collection(db, 'localities'), where('routeId', '==', routeId))
  );
  const localityIds: string[] = [];
  locSnap.forEach(d => localityIds.push(d.id));
  if (localityIds.length === 0) return 0;

  // Step 2: Query outlets in chunks by localityId and status active
  let total = 0;
  for (const ids of chunk(localityIds, 10)) {
    const outSnap = await getDocs(
      query(
        collection(db, 'outlets'),
        where('localityId', 'in', ids),
        where('status', '==', 'active')
      )
    );
    total += outSnap.size;
  }

  return total;
}

/**
 * Optionally count all outlets (any status) mapped to a route.
 */
export async function countAllOutletsForRoute(routeId: string): Promise<number> {
  if (!routeId) return 0;
  const locSnap = await getDocs(
    query(collection(db, 'localities'), where('routeId', '==', routeId))
  );
  const localityIds: string[] = [];
  locSnap.forEach(d => localityIds.push(d.id));
  if (localityIds.length === 0) return 0;

  let total = 0;
  for (const ids of chunk(localityIds, 10)) {
    const outSnap = await getDocs(
      query(
        collection(db, 'outlets'),
        where('localityId', 'in', ids)
      )
    );
    total += outSnap.size;
  }
  return total;
}
